import { useEffect } from "react";
import { getTracking } from "@/lib/api";
import { injectRawHtml } from "@/lib/injectScript";

const gtagSnippet = (id) => `
  <script async src="https://www.googletagmanager.com/gtag/js?id=${id}"></script>
  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${id}');
  </script>
`;

const gtmSnippet = (id) => `
  <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
  var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;
  j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${id}');</script>
`;

const metaPixelSnippet = (id) => `
  <script>
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;
    s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${id}');
    fbq('track', 'PageView');
  </script>
`;

const linkedinSnippet = (id) => `
  <script type="text/javascript">
    _linkedin_partner_id = "${id}";
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(_linkedin_partner_id);
  </script>
  <script type="text/javascript">
    (function(l){if(!l){window.lintrk=function(a,b){window.lintrk.q.push([a,b])};window.lintrk.q=[]}
    var s=document.getElementsByTagName("script")[0];var b=document.createElement("script");
    b.type="text/javascript";b.async=true;b.src="https://snap.licdn.com/li.lms-analytics/insight.min.js";
    s.parentNode.insertBefore(b,s);})(window.lintrk);
  </script>
`;

const claritySnippet = (id) => `
  <script type="text/javascript">
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${id}");
  </script>
`;

// Mounted once at the app root. Fetches admin-configured tracking codes and injects
// them into the live DOM. Injected scripts run for every visitor regardless of route.
const SIMPLE_TRACKERS = [
  { field: "ga4_measurement_id", build: gtagSnippet },
  { field: "gtm_container_id", build: gtmSnippet },
  { field: "meta_pixel_id", build: metaPixelSnippet },
  { field: "linkedin_partner_id", build: linkedinSnippet },
  { field: "clarity_id", build: claritySnippet },
];

const injectSimpleTrackers = (t) => {
  SIMPLE_TRACKERS.forEach(({ field, build }) => {
    if (t[field]) injectRawHtml(build(t[field]));
  });
};

const injectGscVerification = (code) => {
  if (!code) return;
  const meta = document.createElement("meta");
  meta.name = "google-site-verification";
  meta.content = code;
  document.head.appendChild(meta);
};

const injectCustomScripts = (scripts) => {
  (scripts || []).forEach((cs) => {
    if (cs.enabled) injectRawHtml(cs.code, cs.placement === "body_end" ? document.body : document.head);
  });
};

export const TrackingScripts = () => {
  useEffect(() => {
    getTracking()
      .then((t) => {
        if (!t) return;
        injectSimpleTrackers(t);
        injectGscVerification(t.gsc_verification_code);
        injectCustomScripts(t.custom_scripts);
      })
      .catch(() => {});
  }, []);

  return null;
};
